'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var mergeOptions = require('merge-options');

var sha2 = require('multiformats/hashes/sha2');

var murmur3 = require('@multiformats/murmur3');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var mergeOptions__default = /*#__PURE__*/_interopDefaultLegacy(mergeOptions);

function hamtHashFn(_x) {
  return _hamtHashFn.apply(this, arguments);
}

function _hamtHashFn() {
  _hamtHashFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(buf) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return murmur3.murmur3128.encode(buf);

          case 2:
            return _context.abrupt("return", _context.sent.slice(0, 8).reverse());

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _hamtHashFn.apply(this, arguments);
}

var defaultOptions = {
  chunker: 'fixed',
  strategy: 'balanced',
  rawLeaves: false,
  onlyHash: false,
  reduceSingleLeafToSelf: true,
  hasher: sha2.sha256,
  leafType: 'file',
  cidVersion: 0,
  progress: function progress() {
    return function () {};
  },
  shardSplitThreshold: 1000,
  fileImportConcurrency: 50,
  blockWriteConcurrency: 10,
  minChunkSize: 262144,
  maxChunkSize: 262144,
  avgChunkSize: 262144,
  window: 16,
  polynomial: 17437180132763652,
  maxChildrenPerNode: 174,
  layerRepeat: 4,
  wrapWithDirectory: false,
  recursive: false,
  hidden: false,
  timeout: undefined,
  hamtHashFn: hamtHashFn,
  hamtHashCode: 34,
  hamtBucketBits: 8
};

var defaultOptions$1 = function defaultOptions$1() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = mergeOptions__default['default'].bind({
    ignoreUndefined: true
  });
  return defaults(defaultOptions, options);
};

module.exports = defaultOptions$1;